import 'whatwg-fetch';
import {MULTIPLE_CHOICES, OK} from "http-status";

function parseJSON(response) {
  return response.json();
}

function checkStatus(response) {
  if (response.status >= OK && response.status < MULTIPLE_CHOICES) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

export default function request(url, options) {
  return fetch(url, Object.assign({ credentials: 'same-origin' }, options))
    .then(checkStatus)
    .then(parseJSON);
}
